import type { CsvRow } from "@/models/csv-row";

class CsvService {
  getCsvContent(rows: CsvRow[]) {
    const firstRow = rows[0];
    if (!firstRow) {
      throw new Error("CSV must contain at least one row.");
    }

    const headerContent = firstRow.values.map((v) => v.title).join(",");
    const bodyContent = rows
      .map((row) => row.values.map((v) => v.value).join(","))
      .join("\n");

    return `${headerContent}\n${bodyContent}`;
  }
}

export const csvService = new CsvService();
